import { cn } from "@/shared/lib/utils";
import type * as React from "react";
import {
  type FieldValues,
  FormProvider,
  type UseFormReturn,
} from "react-hook-form";

type FormRootProps<T extends FieldValues> = {
  methods: UseFormReturn<T>;
  onSubmit: (values: T) => void | Promise<void>;
  className?: string;
  children: React.ReactNode;
};

export function FormRoot<T extends FieldValues>({
  methods,
  onSubmit,
  className,
  children,
}: FormRootProps<T>) {
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        noValidate
        className={cn("space-y-6", className)}
      >
        {children}
      </form>
    </FormProvider>
  );
}
